import { instance } from "libs/api";

import { ApiRoutesDrivers } from "./../../constants";
import {
  UpdateDriverRequestBody,
  UpdateDriverResponseData
} from "./updateDriver.types";

export const requestUpdateDriver = async (
  body: UpdateDriverRequestBody
): Promise<UpdateDriverResponseData> => {
  return await instance.put(ApiRoutesDrivers.Drivers, body);
};
